import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify'
import { getPeriodAdvertiserPerformance, exportPeriodAdvertiserPerformance } from "../../../services/micro";
import { Button, Card, Col, Nav, Placeholder } from "react-bootstrap";
import { AgSplittedTable } from "../../../components/AgSplittedTable";
import { StatusRenderer } from "../../inventory/components/StatusRenderer";
import { CurrentBudgetRenderer } from "./components/currentBudgetRenderer";
import { useRedirectsContext } from "../../../contexts/RedirectsContext";
import { CampaignTableFilters } from "../../../data/table-filters";
import { useCookiesContext } from "../../../contexts/CookiesContext";

const customColumns = [
  {
    field: "status",
    cellRenderer: StatusRenderer,
  },
  {
    field: "budget",
    cellRenderer: CurrentBudgetRenderer,
  },
];

const colWidths = {
  ID: 100,
  campaign: 120,
  status: 120,
  budget: 120,
  credits: 120,
  bids: 120,
  impressions: 150,
  freeClicks: 150,
  paidClicks: 150,
  averagePos: 150,
  averageCPC: 150,
  topCPC: 150,
  totalSpend: 150,
};


export default function AdvertiserPerformance(props) {
  const { currentPeriod, previousPeriod, skin, accountManagerId } = props;
  const { getPublisherId } = useCookiesContext()
  const [response, setResponse] = useState();
  const [status, setStatus] = useState(1);

  const [countByStatus, setCountByStatus] = useState({
    activeRecords: 0,
    inactiveRecords: 0,
    pausedRecords: 0,
    notBiddingRecords: 0,
    total: 0,
  });

  const {
    openCampaignAdvAunctions,
    openCampaignAdvAnalytics,
    openCampaignEdit,
  } = useRedirectsContext();

  const getContextMenuItems = (params) => {
    const result = [
      {
        name: "Edit " + params.node.data.campaign,
        action: () => {
          openCampaignEdit(params.node.data.ID);
        },
      },
      "separator",
      {
        name: "Open " + params.node.data.campaign + " Auctions",
        action: () => {
          openCampaignAdvAunctions(params.node.data.ID);
        },
      },
      {
        name: "Open " + params.node.data.campaign + " Analytics",
        action: () => {
          openCampaignAdvAnalytics(params.node.data.ID);
        },
      },
      "separator",
      "copy",
    ];
    return result;
  };

  const onRowClick = (event) => {
    openCampaignAdvAunctions(event.data.ID);
  };

  const handleDailyActivityReport = () => {
    exportPeriodAdvertiserPerformance(30, accountManagerId).then().catch(e => {
      toast.error("Data for the last 30 days is not available")
    });
  };

  useEffect(() => {
    setResponse()

    if (currentPeriod && previousPeriod) {
      if (
        currentPeriod[0] &&
        currentPeriod[1] &&
        previousPeriod[0] &&
        previousPeriod[1]
      ) {
        getPeriodAdvertiserPerformance(currentPeriod, previousPeriod, null, null, null, null, null, accountManagerId).then(
          (res) => {
            setResponse(res);
          }
        );
      }
    }
  }, [currentPeriod, previousPeriod, accountManagerId]);

  if (response) {
    const currentColumns = response.data?.columns?.slice(0, 6);
    const periodColumns = response.data?.columns?.slice(6);

    const classifiedColumns = {
      currentColumns,
      periodColumns,
    };

    const isHTR = getPublisherId() === 67

    return (
      <React.Fragment>
        <Col xs="12">
          <Card className="card-one">
            <Card.Header>
              <Card.Title as="h6">Campaign Performance</Card.Title>
              <Nav className="nav-icon nav-icon-sm ms-auto" />
              <Button variant="outline-primary d-flex align-items-center" size="sm" onClick={handleDailyActivityReport}>
                <p className="mb-0">Last 30 days activity report</p>
                <i className="ri-download-line ms-1"></i>
              </Button>

            </Card.Header>
            <Card.Body className="p-3 p-xl-3">
              <CampaignTableFilters countByStatus={countByStatus} status={status} setStatus={setStatus} isHTR={isHTR} />
              <AgSplittedTable
                classifiedColumns={classifiedColumns}
                getData={getPeriodAdvertiserPerformance}
                currentPeriod={currentPeriod}
                previousPeriod={previousPeriod}
                setCountByStatus={setCountByStatus}
                status={status}
                filter={accountManagerId}
                customColumns={customColumns}
                getContextMenuItems={getContextMenuItems}
                skin={skin}
                colWidths={colWidths}
                onRowClick={onRowClick}
              />
            </Card.Body>
          </Card>
        </Col>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Placeholder
          as={Card.Title}
          animation="glow"
          style={{ color: "var(--bs-body-color)" }}
        >
          <Placeholder style={{ height: 400, width: "100%" }} />
        </Placeholder>
      </React.Fragment>
    );
  }
}
